import { render, staticRenderFns } from "./CancellationFrame.vue?vue&type=template&id=266839b4&scoped=true"
import script from "./CancellationFrame.vue?vue&type=script&lang=js"
export * from "./CancellationFrame.vue?vue&type=script&lang=js"
import style0 from "./CancellationFrame.vue?vue&type=style&index=0&id=266839b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266839b4",
  null
  
)

export default component.exports